module.exports = __webpack_public_path__ + "img/img_6.5793f335.jpg";